import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../Note/Notetab';

import { useGetNotesBySourceQuery } from 'store/services/noteApi';
import { useShipmentFulfillmentDetailContext } from "contexts/ShipmentFulfillmentContext";

import CollectionStopsTab from "./CollectionStopsTab";
import CollectionTrackTab from "./CollectionTrackTab";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import CollectionShipmentTab from "./CollectionShipmentTab";

const CollectionDetailTab = () => {

    const [searchParams] = useSearchParams();

    const activeTab = searchParams.get('tab') || 'note';

    const { fulfillmentDetail } = useShipmentFulfillmentDetailContext();


    // Fetch notes to get the count for the badge
    const { data: notes } = useGetNotesBySourceQuery(
        { source: 'Collection', sourceRef: fulfillmentDetail?._id, }, { skip: !fulfillmentDetail?._id }
    );

    // Fetch documents to get the count for the badge
    const { data: documents } = useGetDocumentsBySourceQuery(
        { source: 'Collection', sourceRef: fulfillmentDetail?._id, }, { skip: !fulfillmentDetail?._id }
    );

    const tabs = [
        { label: 'Note', value: 'note', badgeCount: notes?.length || 0, },

        { label: "Stops", value: "stops", badgeCount: fulfillmentDetail?.stops?.length },

        { label: "Tracking", value: "track", badgeCount: fulfillmentDetail?.stops?.length },

        { label: "Document", value: "document", badgeCount: documents?.totalItems },

        { label: "Shipment", value: "shipment", badgeCount: fulfillmentDetail?.shipmentId?.length },

    ];

    return (
        <>
            <CustomTabs tabs={tabs} activeTab={activeTab} />

            {fulfillmentDetail ? (
                <>
                    <CustomTabPanel activeTab={activeTab} value="note">
                        <NoteTab source="Collection" sourceRef={fulfillmentDetail._id} />
                    </CustomTabPanel>

                    <CustomTabPanel activeTab={activeTab} value="stops">
                        <CollectionStopsTab />
                    </CustomTabPanel>

                    <CustomTabPanel activeTab={activeTab} value="track">
                        <CollectionTrackTab />
                    </CustomTabPanel>

                    <CustomTabPanel activeTab={activeTab} value="document">
                        <DocumentsTab source="Collection" sourceRef={fulfillmentDetail._id} />
                    </CustomTabPanel>
                    <CustomTabPanel activeTab={activeTab} value="shipment">
                      <CollectionShipmentTab/>
                    </CustomTabPanel>

                </>
            ) : (
                <RowsSkeleton />
            )}
        </>
    );
};

export default CollectionDetailTab;